// extracted by mini-css-extract-plugin
export default {"slider":"DynSchema_slider__PqKDA","imagecontainer":"DynSchema_imagecontainer__BL-RN","selectbutton":"DynSchema_selectbutton__0X0cM"};